// extracted by mini-css-extract-plugin
export default {"alert-bullet-list":"ShippingToEu_alert-bullet-list__+EG1p"};